// Grant public panel routes
export const systemCheckApplyAuthorization = 'grant-panel/private-orphanage-application/apply-authorization'

// service application routes
export const rehabitationStoreApi = 'grant-panel/service-application/store'
export const rehabitationListApi = 'grant-panel/service-application/list'
export const rehabitationDetailsApi = 'grant-panel/service-application/details'

// Orphanage application routes
export const orphanageStoreApi = 'grant-panel/private-orphanage-application/store'
export const orphanageListApi = 'grant-panel/private-orphanage-application/list'
export const orphanageDetailsApi = 'grant-panel/private-orphanage-application/details'
export const getinstituteInfoApi = 'grant-panel/private-orphanage-application/get-institute-info'
export const privOrphaApplyAuthorization = 'grant-panel/private-orphanage-application/prive-orpha-apply-authorization'
export const reviewsApi = 'grant-panel/private-orphanage-application/reviews-view'

// export const instituteAddressApi = 'grant-panel/private-orphanage-application/get-institute-address'

// institution registration
export const InstitutionInfoStore = 'grant-panel/institution-registration/save-info'
export const InstitutionAddressStore = 'grant-panel/institution-registration/save-address'
export const InstitutionOtherStore = 'grant-panel/institution-registration/save-other'
export const InstitutionList = 'grant-panel/institution-registration/list'
export const InstitutionDetails = 'grant-panel/institution-registration/details'
export const InstitutionReviewDetails = 'grant-panel/institution-registration/review-view'
// export const InstitutionAddressDetails = 'grant-panel/institution-registration/address-details'
export const InstitutionDocument = 'grant-panel/institution-registration/document'
export const checkCirculatedNoticeApi = 'grant-panel/institution-registration/check-circulated-notice'
export const institutionRegistrationOfficeTypeServiceApi = 'grant-panel/institution-registration/office-type-service'

// student Entry

export const StudentEntryExListApi = 'grant-panel/student-entry/list'
export const StudentEntryExListMainApi = 'grant-panel/student-entry/listmain'
export const StudentEntryExListArchiveApi = 'grant-panel/student-entry/listArchive'
export const StudentEntryExStoreApi = 'grant-panel/student-entry/store'
export const StudentEntryExUpdateApi = 'grant-panel/student-entry/update'
export const StudentExShowApi = 'grant-panel/student-entry/show'
export const StudentExArchiveReviewApi = 'grant-panel/student-entry/archive-review-store'

// medical treatment (version - 1)
export const medicalTreatmentStore = 'grant-panel/medical-treatment/store'
export const medicalTreatmentList = 'grant-panel/medical-treatment/list'
export const medicalTreatmentDetails = 'grant-panel/medical-treatment/details'
export const medicalTreatmentDetailsx = 'grant-panel/medical-treatment/detailsx'

// medical treatment (version - 2)
export const medicalGeneralStoreApi = 'grant-panel/medical-treatment/general-store'
export const medicalBeneficiaryStoreApi = 'grant-panel/medical-treatment/beneficiary-store'
export const medicalAddressStoreApi = 'grant-panel/medical-treatment/address-store'
export const medicalAttachmentStoreApi = 'grant-panel/medical-treatment/attachment-store'
export const medicalTreatmenOfficeTypeServiceApi = 'grant-panel/medical-treatment/office-type-service'
export const medTreatApplyAuthorization = 'grant-panel/medical-treatment/med-treat-apply-authorization'

// Medical Assistance Api
export const mediAssisBaseUrl = '/grant-panel/medical-assistance'
export const mediAssistanceList = mediAssisBaseUrl + '/list'
export const mediAssistanceStore = mediAssisBaseUrl + '/store'
export const mediAssistanceDetails = mediAssisBaseUrl + '/details'
export const mediAssistanceUpdate = mediAssisBaseUrl + '/update'

// National Disability Development Foundation Grant Api
export const nationalDisabilityDevBaseUrl = '/grant-panel/national-disability-development-foundation'
export const nationalDisabilityDevList = nationalDisabilityDevBaseUrl + '/list'
export const nationalDisabilityDevStore = nationalDisabilityDevBaseUrl + '/store'
export const nationalDisabilityDevDetails = nationalDisabilityDevBaseUrl + '/details'
export const nationalDisabilityDevUpdate = nationalDisabilityDevBaseUrl + '/update'

// Scholarship Shishu Paribar
export const scholarshipBaseUrl = '/grant-panel/scholarship-shishu-paribar'
export const scholarshipListApi = scholarshipBaseUrl + '/list'
export const scholarshipStoreApi = scholarshipBaseUrl + '/store'
export const scholarshipUpdateApi = scholarshipBaseUrl + '/update'
export const scholarshipDetailsApi = scholarshipBaseUrl + '/details'

// National Disability Development Foundation Grant (Personal)
export const personalGrantBaseUrl = '/grant-panel/national-disability-development-foundation-grant-personal'
export const personalGrantListApi = personalGrantBaseUrl + '/list'
export const personalGrantStoreApi = personalGrantBaseUrl + '/store'
export const personalGrantUpdateApi = personalGrantBaseUrl + '/update'
export const personalGrantDetailsApi = personalGrantBaseUrl + '/details'

// Registered General Voluntary Organization
export const regVolOrgBaseUrl = '/grant-panel/registered-general-voluntary-organization'
export const regVolOrgListApi = regVolOrgBaseUrl + '/list'
export const regVolOrgStoreApi = regVolOrgBaseUrl + '/store'
export const regVolOrgUpdateApi = regVolOrgBaseUrl + '/update'
export const regVolOrgDetailsApi = regVolOrgBaseUrl + '/details'

// Criminal Rehabilitation Association
export const criminalRehabilitationBaseUrl = '/grant-panel/criminal-rehabilitation-association'
export const criminalRehabilitationListApi = criminalRehabilitationBaseUrl + '/list'
export const criminalRehabilitationStoreApi = criminalRehabilitationBaseUrl + '/store'
export const criminalRehabilitationUpdateApi = criminalRehabilitationBaseUrl + '/update'
export const criminalRehabilitationDetailsApi = criminalRehabilitationBaseUrl + '/details'

// Patient welfare association application routes
export const welfareAssocStoreApi = 'grant-panel/patient-welfare-assoc/store'
export const welfareAssocListApi = 'grant-panel/patient-welfare-assoc/list'
export const welfareAssocDetailsApi = 'grant-panel/patient-welfare-assoc/details'
export const patLevelAgreementApi = 'grant-panel/patient-welfare-assoc/agreement'
export const patLevelAgreementDetailsApi = 'grant-panel/patient-welfare-assoc/agreement-details'

// Special Grant
export const specialGrantBaseUrl = '/grant-panel/special-grant'
export const specialGrantListApi = specialGrantBaseUrl + '/list'
export const specialGrantStoreApi = specialGrantBaseUrl + '/store'
export const specialGrantUpdateApi = specialGrantBaseUrl + '/update'
export const specialGrantDetailsApi = specialGrantBaseUrl + '/details'

// application form
export const applicationFormStoreApi = 'configuration/application-form/store'
export const applicationFormListApi = 'configuration/application-form/list'

// UCD Development routes
export const ucdDevelopmentStoreApi = 'grant-panel/ucd-development/store'
export const ucdDevelopmentListApi = 'grant-panel/ucd-development/list'
export const ucdDevelopmentDetailsApi = 'grant-panel/ucd-development/details'

// National level grant
export const nationalLevelGrantStore = 'grant-panel/national-level-grant/store'
export const nationalLevelGrantList = 'grant-panel/national-level-grant/list'
export const nationalLevelGrantDetails = 'grant-panel/national-level-grant/details'

export const natLevelBaseUrl = '/grant-panel/nat-level-grant'
export const natLevelListApi = natLevelBaseUrl + '/list'
export const natLevelStoreApi = natLevelBaseUrl + '/store'
export const natLevelUpdateApi = natLevelBaseUrl + '/update'
export const natLevelDetailsApi = natLevelBaseUrl + '/details'
export const natLevelAgreementApi = natLevelBaseUrl + '/agreement'
export const natLevelAgreementDetailsApi = natLevelBaseUrl + '/agreement-details'

// coordinationCouncil grant
export const coordinationCouncilGrantStore = 'grant-panel/coordination-council-grant/store'
export const coordinationCouncilGrantList = 'grant-panel/coordination-council-grant/list'
export const coordinationCouncilGrantDetails = 'grant-panel/coordination-council-grant/details'

export const coordinationCouncilBaseUrl = '/grant-panel/coordination-council-grant'
export const coordinationCouncilListApi = coordinationCouncilBaseUrl + '/list'
export const coordinationCouncilStoreApi = coordinationCouncilBaseUrl + '/store'
export const coordinationCouncilUpdateApi = coordinationCouncilBaseUrl + '/update'
export const coordinationCouncilDetailsApi = coordinationCouncilBaseUrl + '/details'
export const coordinationCouncilAgreementApi = coordinationCouncilBaseUrl + '/agreement'
export const coordinationCouncilAgreementDetailsApi = coordinationCouncilBaseUrl + '/agreement-details'

// correctionOfOffender grant
export const correctionOfOffenderGrantStore = 'grant-panel/correction-of-offender-grant/store'
export const correctionOfOffenderGrantList = 'grant-panel/correction-of-offender-grant/list'
export const correctionOfOffenderGrantDetails = 'grant-panel/correction-of-offender-grant/details'

export const correctionOfOffenderBaseUrl = '/grant-panel/correction-of-offender-grant'
export const correctionOfOffenderListApi = correctionOfOffenderBaseUrl + '/list'
export const correctionOfOffenderStoreApi = correctionOfOffenderBaseUrl + '/store'
export const correctionOfOffenderUpdateApi = correctionOfOffenderBaseUrl + '/update'
export const correctionOfOffenderDetailsApi = correctionOfOffenderBaseUrl + '/details'
export const correctionOfOffenderAgreementApi = correctionOfOffenderBaseUrl + '/agreement'
export const correctionOfOffenderAgreementDetailsApi = correctionOfOffenderBaseUrl + '/agreement-details'

/** Dashboard */
export const dashboardApi = 'registration-management/dashboard/list'

/** user wise service application */
export const userWiseServiceApplicationList = 'grant-panel/user-wise-service-application-list/list'

// load form documents
export const loadFormDocumentApi = 'configuration/application-form'

// Payment apis
export const paymentOfflineApi = '/grant-panel/application/payment-offline'
export const processApplicationDetails = '/grant-panel/application/details'
export const paymentOnlineApi = '/grant-panel/application/payment-online'
export const paymentUpdateStatusApi = '/grant-panel/application/'
export const paymentReceiptApi = '/grant-panel/application/payment-receipt'

export const disabilityTypeListApi = 'configuration/disability-type/list'
export const nidApi = 'nid/voter-details'
